export const isDev = () => {
    return import.meta.env.VITE_ENV === 'dev'
  }